import React from "react";
import useStyles from "../Styles";
import { Box } from "@material-ui/core";
import toggleIcon from "../../../assets/slide-out-icon.png";
import AboutSidebar from "./AboutSidebar";
import userActions from "../actions";
import { useSelector } from "react-redux";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

const AboutTogglebar = (props) => {
  const classes = useStyles();
  const { about } = props;
  const { toggleAboutDrawer } = userActions();
  const { toggle_about } = useSelector((state) => state.technical_view);
  const { isMobile } = useGetViewPortDimensions();

  return (
    <>
      {!toggle_about && !isMobile ? (
        <Box className={classes.aboutTogglebar} onClick={toggleAboutDrawer}>
          <img src={toggleIcon} className={classes.aboutToggleIcon} alt="toggle-icon" />
        </Box>
      ) : (
        <Box
          className={
            isMobile ? classes.aboutDrawerResponsive : classes.aboutDrawer
          }
        >
          <AboutSidebar onClose={toggleAboutDrawer} about={about} />
        </Box>
      )}
    </>
  );
};

export default AboutTogglebar;
